import React, { Component, Fragment } from 'react'
import { RadioCard, RadioCardItem, Field, HealtheraButton, FabIcon } from '../../healtheraComponents'
import { Radio, InputAdornment, Select, InputLabel, FormControl, Switch, FormControlLabel } from '@material-ui/core'
import styled from 'styled-components'
import Circle from '@material-ui/icons/Lens'
import { connect } from 'react-redux'
import * as actions from '../../redux/authentication'

class DynamicForm extends Component {

  state = { values: {} }

  componentDidMount() {
    this.setState({
      data: this.props.fields,
      enclosed: this.props.enclosed,
      editable: this.props.editable,
      displayButtons: this.props.displayButtons,
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.fields !== nextProps.fields)
      this.setState({ data: nextProps.fields })
  }

  async handleChange(item, { target: { value } }) {

    if (item.locked) {
      return false
    }

    item.validation.validate(value.trim())
      .then(() => {
        item.helperText = ''
      })
      .catch(({ errors: [err] }) => {
        item.helperText = err
      })
      .finally(() => {
        const castedValue = typeof item.cast === 'function' ? item.cast(value) : value;
        if (item.defaultValue)
          item.defaultValue = castedValue
        else {
          item.value = castedValue
          this.forceUpdate()
        }

        this.setState({ data: this.state.data })

        if (this.props.onChange) {
          this.props.onChange({
            field: item.field,
            value: castedValue,
            validation: (item.helperText === undefined || item.helperText === ''),
          })
        }
      })
  }

  handleClick(e) {
    e.preventDefault()
    this.setState({ editable: false })
  }

  handleSave(e) {
    e.preventDefault()
    this.setState({ editable: true })
    // Call parent to PUT
    this.props.save()
  }

  handleDelete(e) {
    e.preventDefault()
    this.setState({ editable: true, data: this.props.fields })
    // Call parent to DELETE
    this.props.delete()
  }

  handleCancel(e) {
    e.preventDefault()
    this.setState({ editable: true })

    const { onCancel } = this.props
    onCancel && onCancel()
  }

  onKeyPress(event) {
    if (event.which === 13) {
      event.preventDefault()
    }
  }

  onCheckboxUpdate(field, value, i) {
    value = { ...value, enabled: !value.enabled }
    let values = this.state.data.values
    values.splice(i, 1, value)

    this.setState({ data: { ...this.state.data, values } })
    this.props.onCheckboxUpdate(field, this.state.data)

  }

  render() {
    let { data = {}, editable, displayButtons, enclosed } = this.state
    const { displayDeleteButton } = this.props

    const {
      subtitle,
      title,
      position,
      margintop,
      big,
      fields,
      onChange,
      disabled,
      disableForm,
      extended,
    } = this.props

    return (
      <Form onKeyPress={this.onKeyPress}>
        <Fragment>
          <FormHeader>
            {title}
          </FormHeader>
          {editable && (
            <LinkText position={position} onClick={this.handleClick.bind(this)}>Edit</LinkText>
          )}
        </Fragment>
        {
          !editable &&
          data &&
          data.type !== 'radio' &&
          data.type !== 'checkbox' &&
          Object.keys(data).map((item) => {
            if (data[item]) {
              if (data[item].type === 'switch') {
                return (
                  <Fragment key={item}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!!data[item].value}
                          onChange={(e) => {
                            if (onChange) onChange({ field: data[item].field, value: e.target.checked })
                          }}
                          value={data[item].field}
                          color="primary"
                        />
                      }
                      label={item}
                      style={{ marginTop: margintop || '20px', width: '100%', marginLeft: '0px' }}
                    />
                  </Fragment>
                )
              }

              if (data[item].type === 'select') {
                return (
                  <SelectFormControl key={item}>
                    <InputLabel>{item}</InputLabel>
                    <Select
                      native
                      disabled={data[item].disabled}
                      value={data[item].value}
                      onChange={({ target: { value } }) => {
                        // Keep local form state in sync so selects update visually while editing
                        data[item].value = value;
                        this.setState({ data: { ...data } });

                        if (onChange) onChange({ field: data[item].field, value });
                      }}
                    >
                      {data[item].values && data[item].values.map((value, i) => {
                        const disabled = data[item].disabledOption && value === data[item].disabledOption && !data[item].disable;
                        return <option key={i} disabled={disabled} value={value ?? String(value)}>{data[item].labels ? data[item].labels[i] : value}</option>
                      })}
                    </Select>
                  </SelectFormControl>
                )
              }

              if (!['select', 'editableSelect'].includes(data[item].type)) {
                const isMultiline = !!data[item].multiline;
                const rows = isMultiline ? 3 : 1;

                return (
                  <Fragment key={item}>
                    {!data[item].locked && (
                      <Field
                        InputProps={{
                          startAdornment: (data[item].color && (
                            <InputAdornment position='start'>
                              {data[item].color && <ColorFlag colour={data[item].color} />}
                            </InputAdornment>
                          ))
                        }}
                        name={item}
                        helperText={data[item].helperText || ' '}
                        key={data[item].key}
                        defaultValue={data[item].defaultValue}
                        margintop={margintop}
                        onChange={this.handleChange.bind(this, data[item])}
                        label={item}
                        value={data[item].value}
                        multiline={isMultiline}
                        rowsMax={rows}
                        placeholder={data[item].placeholder}
                        disabled={disableForm || data[item].disabled}
                        type={data[item].type || 'text'}
                        InputLabelProps={{ shrink: true }}
                      >
                      </Field>
                    )}
                  </Fragment>
                );
              }

              if (data[item].type === 'editableSelect') {
                return (
                  <Fragment key={item}>
                    <EditableSelectFormControl>
                      <InputLabel>{item}</InputLabel>
                      <Select
                        native
                        disabled={data[item].disabled}
                        value={data[item].value}
                        defaultValue={data[item].defaultValue}
                        onChange={({ target: { value } }) => { if (onChange) onChange({ field: data[item].field, value }) }}
                      >
                        {data[item].values && data[item].values.map((value, i) => {
                          let disable = false;
                          if (value === data[item].disabledOption && !data[item].disable) disable = data[item].disable = true;
                          return <option key={i} disabled={disable} value={value}>{value}</option>
                        })}
                      </Select>
                    </EditableSelectFormControl>
                  </Fragment>
                );
              }
            }

            return null;
          })
        }
        {
          editable &&
          !enclosed &&
          data &&
          data.type !== 'radio' &&
          data.type !== 'checkbox' &&
          Object.keys(data).map(item => data[item] && data[item].type !== 'date' && (
            <Content key={item}>
              <p><b>{item}:</b> {data[item].defaultValue}</p>
            </Content>
          ))
        }
        {!editable && displayButtons &&
          <Fragment>
            <HealtheraButton
              width={`85px`}
              height={`40px`}
              margin={`20px 0 0 0`}
              onClick={this.handleCancel.bind(this)}
            >
              Cancel
            </HealtheraButton>
            <HealtheraButton
              background={disabled ? '#bbbbbb' : '#2f9d6d'}
              disabled={disabled}
              width={`85px`}
              height={`40px`}
              margin={`20px 0 0 15px`}
              onClick={this.handleSave.bind(this)}
            >
              Save
            </HealtheraButton>
            {displayDeleteButton && (
              <HealtheraButton
                background={disabled ? '#bbbbbb' : '#2f9d6d'}
                disabled={disabled}
                width={`85px`}
                height={`40px`}
                margin={`20px 0 0 15px`}
                onClick={this.handleDelete.bind(this)}
              >
                Delete
              </HealtheraButton>
            )}
          </Fragment>
        }
        {data && data.type === 'radio' && (
          <RadioCard
            disabled={disabled}
            value={data.value}
            defaultValue={data.defaultValue}
            name={data.field}
            onChange={({ target: { value } }) => {
              if (onChange) onChange({ field: data.field, value })
            }}
          >
            {data.values && data.values.map((value, i) => (
              <RadioCardItem
                disabled={disabled}
                tier={fields.tier}
                big={big}
                key={i}
                value={value + ''}
                control={<Radio />}
                label={(big ? '£' : '') + value + ''}
              />
            ))}
          </RadioCard>
        )}
        { /* Checkboxes  */}
        {data && data.type === 'checkbox' && (
          <Fragment>
            <Subtitle> {subtitle} </Subtitle>
            {data.values && data.values.map((value, i) => (
              <CheckBoxIcon
                disabled={disabled}
                extended={extended ? 1 : 0}
                enabled={value.enabled ? 1 : 0}
                key={i}
                onClick={() => this.onCheckboxUpdate(data.field, value, i)}
              >
                {!extended ? value.label[0] : value.label}
              </CheckBoxIcon>
            ))}
          </Fragment>
        )}
      </Form>
    )
  }
}

export default connect((state) => ({ exists: state.authentication.userExists, roles: state.authentication.roles }), actions)(DynamicForm)

const Form = styled.form`
    &&
    {
        position:relative;
        padding-right:16px;
    }
`
const SelectFormControl = styled(FormControl)`
    &&
    {
        min-width: 100%;
        margin-top: 20px;
    }`;

const EditableSelectFormControl = styled(SelectFormControl)`
    width: 100%;
    margin-top: 5px !important;
`;
const LinkText = styled.button`
    &&
    {
        position: ${props => props.position ? props.position : `unset`};
        font-family: Assistant;
        background:none;
        border:0;
        font-size: 16px;
        right: 0;
        color: #2f9d6d;
        top: 0;
        cursor:pointer;
    }
`

const Content = styled.div`
    && p
    {
        font-size: 16px;
        word-wrap: break-word;
    }
    && p b
    {
        width: 150px;
        display: inline-block;
        font-weight: 600;
    }
`
const FormHeader = styled.span`
    &&
    {
        font-size: 16px;
        font-weight: 800;
    }
`
const ColorFlag = styled(Circle)`
    &&
    {
        color: ${props => props.colour ? props.colour : `white`};
        padding-bottom: 5px;
    }
`
const CheckBoxIcon = styled(FabIcon)`
    &&
    {
        color: ${props => props.enabled ? `white` : `black`};
        background: ${props => props.enabled ? `#2f9d6d` : `white`};
        border-radius: ${props => props.extended ? `0` : `50%`};
        width: ${props => props.extended ? `auto` : ``};
        padding: ${props => props.extended ? `0 10px` : ``};
        margin: 3px;
    }
`

const Subtitle = styled.p`
    &&
    {
        font-size:16px;
    }
`
